import _JSXStyle from "styled-jsx/style";
import { useDataQuery } from '@dhis2/app-runtime';
import { LogoIconWhite } from '@dhis2-ui/logo';
import React from 'react';
const logoStyles = {
  styles: /*#__PURE__*/React.createElement(_JSXStyle, {
    id: "3467673193"
  }, ["svg.jsx-3467673193{height:25px;width:27px;}", "img.jsx-3467673193{max-height:100%;min-height:auto;width:auto;}"]),
  className: "jsx-3467673193"
};
const query = {
  customLogo: {
    resource: 'staticContent/logo_banner'
  }
};
const pathExists = data => data && data.customLogo && data.customLogo.images && data.customLogo.images.png;
export const LogoImage = () => {
  const {
    loading,
    error,
    data
  } = useDataQuery(query);
  if (loading) {
    return null;
  }
  let Logo;
  if (!error && pathExists(data)) {
    Logo = /*#__PURE__*/React.createElement("img", {
      alt: "Headerbar Logo",
      src: data.customLogo.images.png,
      className: logoStyles.className
    });
  } else {
    Logo = /*#__PURE__*/React.createElement(LogoIconWhite, {
      className: logoStyles.className
    });
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "jsx-3930434724"
  }, Logo, logoStyles.styles, /*#__PURE__*/React.createElement(_JSXStyle, {
    id: "3930434724"
  }, ["div.jsx-3930434724{padding:4px;min-width:48px;max-width:250px;height:48px;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;overflow:hidden;}"]));
};